<script setup lang="ts">
import { object, string } from 'yup'
import { Form, Field } from 'vee-validate';

const { validateFaChar ,validateMobile, numberOnly, pasteNumber }  = useInputHelpers();
const { post, loading } = useSendMail();

const userInfo = {
  name: "",
  number: "",
  targetNumber: "",
};
const schema = object({
  name: string()
    .required("این فیلد نباید خالی باشد.")
    .test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
  number: string()
    .required("این فیلد نباید خالی باشد.")
    .test("", "مقدار وارد شده معتبر نیست.", validateMobile),
  targetNumber: string()
    .test("", "مقدار وارد شده معتبر نیست.", function (item) {
      if (!item) return true;
      return item.length >= 4 && item.length < 12;
    }),
});

const isSuccess = ref(false);
async function onSubmit(form: any, { resetForm }: any) {
  if (!loading.value) {
    const { data, error } = await post({ body: { model: form } }) as any;
    if (!error.value && data.value === 'ok') {
      isSuccess.value = true;
      resetForm();
    }
  }
};
</script>

<template>
  <div 
    class="w-[90%] lg:w-[83%] backdrop-blur-[20px] card-shadow p-1 relative bg-gradient-to-tr 
      from-transparent to-white rounded-[20px]"
  >
    <Form
      class="w-full h-full p-7 flex flex-col gap-5 lg:gap-8 items-center bg-[#FFFFFFD1] 
        border-[1px] border-[#B3E1FF] rounded-[20px] [&>h3]:text-[#0085DB] [&>span]:text-[#72758D]"
      :validationSchema="schema"
      :initialValues="userInfo"
      v-slot="{ handleSubmit, submitCount }"
    >
    <h3 class="text-xl lg:text-[2rem] font-bold text-center">در یک قدمی ابری شدن</h3>
    <span class="text-xs lg:text-sm text-center -mt-1 lg:-mt-5 leading-[1.2rem] lg:px-10">
      کارشناسان ما در کوتاه‌ترین زمان ممکن با شما تماس می‌گیرند و پاسخگوی تمام سوالات شما خواهند بود.
    </span>
    <Field class="w-full" as="div" name="name" v-slot="{ field, errors }">
      <div class="w-full flex items-center relative">
        <IconUser class="icon w-[24px] text-[#ABB3C0]" />
        <input
          id="name" 
          autocomplete="off" 
          type="text" 
          v-bind="field" 
          placeholder="نام و نام خانوادگی"
          class="!bg-[#F3F7FF] border-[#E6E8EA] text-gray-500 placeholder:text-[#ABB3C0] focus:!border-[#9ED8FF]"
          :class="(errors.length && submitCount > 0) && 'err'"
        >
      </div>
      <p v-if="(errors.length && submitCount > 0)" class="error-text">{{ errors[0] }}</p>
    </Field>
    <Field class="w-full" as="div" name="number" v-slot="{ field, errors }">
      <div class="w-full flex items-center relative">
        <IconPhone class="icon w-[20px] text-[#ABB3C0]" />
        <input
          id="phone" 
          autocomplete="off" 
          type="text" 
          v-bind="field" 
          placeholder="شماره تماس"
          class="!bg-[#F3F7FF] border-[#E6E8EA] text-gray-500 placeholder:text-[#ABB3C0] focus:!border-[#9ED8FF]"
          :class="(errors.length && submitCount > 0) && 'err'"
          @keypress="numberOnly"
          @paste="pasteNumber"
        >
      </div>
      <p v-if="(errors.length && submitCount > 0)" class="error-text">{{ errors[0] }}</p>
    </Field>
    <Field class="w-full" as="div" name="targetNumber" v-slot="{ field, errors }">
      <div class="w-full flex items-center relative">
        <IconPhone class="icon w-[20px] text-[#ABB3C0]" />
        <input
          id="phone" 
          autocomplete="off" 
          type="text" 
          v-bind="field" 
          placeholder="شماره‌ ثابتی که می‌خواهید ابری شود"
          class="!bg-[#F3F7FF] border-[#E6E8EA] text-gray-500 placeholder:text-[#ABB3C0] focus:!border-[#9ED8FF]"
          :class="(errors.length && submitCount > 0) && 'err'"
          @keypress="numberOnly"
          @paste="pasteNumber"
        >
      </div>
      <p v-if="(errors.length && submitCount > 0)" class="error-text">{{ errors[0] }}</p>
    </Field>
    <Button
      v-if="!isSuccess"
      class="order-1 lg:order-2 w-full!"
      :loading="loading"
      pill
      @click.prevent="handleSubmit(onSubmit)"
    >
        ارسال درخواست
    </Button>
    <p v-else class="text-body1-bold text-success-600 h-10">اطلاعات شما با موفقیت ارسال شد!</p>
    </Form>
    <IconLandingRays class="absolute -left-6 -top-8 z-[-1]" />
  </div>
</template>

<style scoped>
@reference "~/assets/css/main.css";

input {
  @apply
  w-full h-10 rounded-[12px] py-2 px-3 pr-10 cursor-pointer text-sm border-[1px] transition-all duration-300
  focus:!border-[#9ED8FF]
}
input:hover {
  box-shadow: 0 2px 4px -4px rgba(17, 28, 45, 0.06), 0 1px 8px -2px rgba(17, 28, 45, 0.08);
}
input.err {
  box-shadow: 0 8px 24px -4px rgba(251, 151, 125, 0.08), 0 6px 12px -6px rgba(251, 151, 125, 0.12);
  @apply
  border-[#FDCBBF]
}
.icon {
  @apply
  absolute right-[9px] aspect-square
}
.error-text {
  @apply
  text-red-500 text-xs mt-1 font-bold
}
.card-shadow {
  box-shadow: 0 4px 21px #0085DB14;
}
</style>